import * as React from "react";
import { timestampToLongDate } from "src/share/utils/utils";

const GFCaseInformation = ({ location, agency, openDate, circumstances }) => {
  return (
    <div className="geosearch-form__case-information">
      <div className="geosearch-form__case-line">
        <h5>Case Location:</h5>
        <p>{location}</p>
      </div>
      <div className="geosearch-form__case-line">
        <h5>Open Date:</h5>
        <p>{openDate && timestampToLongDate(openDate)}</p>
      </div>
      <div className="geosearch-form__case-line">
        <h5>Agency:</h5>
        <p>{agency}</p>
      </div>
      <div className="geosearch-form__case-line">
        <h5>Missing Circumstances:</h5>
        <p>{circumstances}</p>
      </div>
    </div>
  );
};

export default GFCaseInformation;
